<!-- 
 @fileoverview This is the Agent Result page template
 @author Harish Kumaran
 @created June, 2024
 -->
<div class="layout">
  <div class="heading">
    <h1>Humana</h1>
  </div>
  <div class="container col-md-9 mb-1 mt-1">
    <div class="row">
      <div class="search col-6">
        <label for="search"></label>
        <input placeholder="Search by Application ID" id="search" matInput type="text" [(ngModel)]="applicationID"
          (input)="search($event)" maxlength="18" pattern="\d*" class="w-full border p-2 rounded-lg" />
      </div>
      <div class="col-3 text-center"></div>
      <div class="col-3 text-center"></div>
    </div>
    <div class="spinner" *ngIf="isLoading">
      <div class="custom-spinner"></div>
    </div>
    <div *ngIf="errorMessage" class="error-message">
      {{ errorMessage }}
    </div>
    <div *ngIf="!errorMessage && isDataEmpty" class="error-message">
      No data available.
    </div>
    <div class="my-table mt-2 mb-1">
      <table mat-table *ngIf="actualData && actualData.length > 0" [dataSource]="dataSource" matSort>
        <ng-container matColumnDef="memberFirstName">
          <th mat-header-cell *matHeaderCellDef>
            <div class="header-content">
              <span class="header-title">First Name</span>
              <button class="icon-button" (click)="openFilterDialog('memberFirstName')">
                <mat-icon class="header-icon">filter_alt</mat-icon>
              </button>
              <button class="icon-button" (click)="sortData('memberFirstName')">
                <mat-icon class="header-icon">swap_vert</mat-icon>
              </button>
            </div>
          </th>
          <td mat-cell *matCellDef="let element; let i = index"
            [ngClass]="[getRowClass(element.applicationStatus,element.statusReason), 'all-rows']">
            {{ element.memberFirstName }}
          </td>
        </ng-container>

        <ng-container matColumnDef="memberLastName">
          <th mat-header-cell *matHeaderCellDef>
            <div class="header-content">
              <span class="header-title">Last Name</span>
              <button class="icon-button" (click)="openFilterDialog('memberLastName')">
                <mat-icon class="header-icon">filter_alt</mat-icon>
              </button>
              <button class="icon-button" (click)="sortData('memberLastName')">
                <mat-icon class="header-icon">swap_vert</mat-icon>
              </button>
            </div>
          </th>
          <td mat-cell *matCellDef="let element; let i = index"
            [ngClass]="[getRowClass(element.applicationStatus,element.statusReason), 'all-rows']">
            {{ element.memberLastName }}
          </td>
        </ng-container>

        <ng-container matColumnDef="applicationStatus">
          <th mat-header-cell *matHeaderCellDef>
            <div class="header-content">
              <span class="header-title">Status</span>
              <button class="icon-button" (click)="openFilterDialog('applicationStatus')">
                <mat-icon class="header-icon">filter_alt</mat-icon>
              </button>
              <button class="icon-button" (click)="sortData('applicationStatus')">
                <mat-icon class="header-icon">swap_vert</mat-icon>
              </button>
            </div>
          </th>
          <td mat-cell *matCellDef="let element; let i = index"
            [ngClass]="[getRowClass(element.applicationStatus,element.statusReason), 'all-rows']">
            {{ element.applicationStatus ?? "Invalid Application" }}
          </td>
        </ng-container>

        <ng-container matColumnDef="statusReason">
          <th mat-header-cell *matHeaderCellDef>
            <div class="header-content">
              <span class="header-title">Status Reason</span>
              <button class="icon-button" (click)="openFilterDialog('statusReason')">
                <mat-icon class="header-icon">filter_alt</mat-icon>
              </button>
              <button class="icon-button" (click)="sortData('statusReason')">
                <mat-icon class="header-icon">swap_vert</mat-icon>
              </button>
            </div>
          </th>
          <td mat-cell *matCellDef="let element; let i = index"
            [ngClass]="[getRowClass(element.applicationStatus,element.statusReason),'all-rows']">
            {{ element.statusReason }}
          </td>
        </ng-container>

        <ng-container matColumnDef="statusReasonDescription" mat>
          <th mat-header-cell *matHeaderCellDef>
            <div class="header-content">
              <span class="header-title">Description</span>
              <button class="icon-button" (click)="openFilterDialog('statusReasonDescription')">
                <mat-icon class="header-icon">filter_alt</mat-icon>
              </button>
              <button class="icon-button" (click)="sortData('statusReasonDescription')">
                <mat-icon class="header-icon">swap_vert</mat-icon>
              </button>
            </div>
          </th>
          <td mat-cell *matCellDef="let element; let i = index"
            [ngClass]="[getRowClass(element.applicationStatus,element.statusReason),'all-rows']">
            {{ element.statusReasonDescription }}
          </td>
        </ng-container>
        <ng-container matColumnDef="applicationSystemSubmitCode">
          <th mat-header-cell *matHeaderCellDef>
            <div class="header-content">
              <span class="header-title">Enrollment Tool</span>
              <button class="icon-button" (click)="openFilterDialog('applicationSystemSubmitCode')">
                <mat-icon class="header-icon">filter_alt</mat-icon>
              </button>
              <button class="icon-button" (click)="sortData('applicationSystemSubmitCode')">
                <mat-icon class="header-icon">swap_vert</mat-icon>
              </button>
            </div>
          </th>
          <td mat-cell *matCellDef="let element; let i = index"
            [ngClass]="[getRowClass(element.applicationStatus,element.statusReason), 'all-rows']">
            {{ element.applicationSystemSubmitCode }}
          </td>
        </ng-container>
        <ng-container matColumnDef="applicationID">
          <th mat-header-cell *matHeaderCellDef>
            <div class="header-content">
              <span class="header-title">Application ID</span>
              <button class="icon-button" (click)="sortData('applicationID')">
                <mat-icon class="header-icon">swap_vert</mat-icon>
              </button>
            </div>
          </th>
          <td mat-cell *matCellDef="let element; let i = index"
            [ngClass]="[getRowClass(element.applicationStatus,element.statusReason),'all-rows']">
            {{ element.applicationID }}
          </td>
        </ng-container>

        <ng-container matColumnDef="coverageEffectiveDate">
          <th mat-header-cell *matHeaderCellDef>
            <div class="header-content">
              <span class="header-title">Plan Effective Date</span>
              <button class="icon-button" (click)="openFilterDialog('coverageEffectiveDate')">
                <mat-icon class="header-icon">filter_alt</mat-icon>
              </button>
              <button class="icon-button" (click)="sortData('coverageEffectiveDate')">
                <mat-icon class="header-icon">swap_vert</mat-icon>
              </button>
            </div>
          </th>
          <td mat-cell *matCellDef="let element; let i = index"
            [ngClass]="[getRowClass(element.applicationStatus,element.statusReason), 'all-rows']">
            {{ element.coverageEffectiveDate }}
          </td>
        </ng-container>

        <ng-container matColumnDef="submisssionDate">
          <th mat-header-cell *matHeaderCellDef>
            <div class="header-content">
              <span class="header-title">Submission Date</span>
              <button class="icon-button" (click)="openFilterDialog('submisssionDate')">
                <mat-icon class="header-icon">filter_alt</mat-icon>
              </button>
              <button class="icon-button" (click)="sortData('submisssionDate')">
                <mat-icon class="header-icon">swap_vert</mat-icon>
              </button>
            </div>
          </th>
          <td mat-cell *matCellDef="let element; let i = index"
            [ngClass]="[getRowClass(element.applicationStatus,element.statusReason), 'all-rows']">
            {{ element.submisssionDate }}
          </td>
        </ng-container>

        <ng-container matColumnDef="lastUpdatedDate">
          <th mat-header-cell *matHeaderCellDef>
            <div class="header-content">
              <span class="header-title">Status Last Updated</span>
              <button class="icon-button" (click)="sortData('lastUpdatedDate')">
                <mat-icon class="header-icon">swap_vert</mat-icon>
              </button>
            </div>
          </th>
          <td mat-cell *matCellDef="let element; let i = index"
            [ngClass]="[getRowClass(element.applicationStatus,element.statusReason), 'all-rows']">
            {{ element.lastUpdatedDate }}
          </td>
        </ng-container>

        <ng-container matColumnDef="planName">
          <th mat-header-cell *matHeaderCellDef>
            <div class="header-content">
              <span class="header-title">Plan Name</span>
              <button class="icon-button" (click)="openFilterDialog('planName')">
                <mat-icon class="header-icon">filter_alt</mat-icon>
              </button>
              <button class="icon-button" (click)="sortData('planName')">
                <mat-icon class="header-icon">swap_vert</mat-icon>
              </button>
            </div>
          </th>
          <td mat-cell *matCellDef="let element; let i = index"
            [ngClass]="[getRowClass(element.applicationStatus,element.statusReason), 'all-rows']">
            {{ element.planName }}
          </td>
        </ng-container>

        <ng-container matColumnDef="planNumber">
          <th mat-header-cell *matHeaderCellDef>
            <div class="header-content">
              <span class="header-title">Plan Number</span>
              <button class="icon-button" (click)="openFilterDialog('planNumber')">
                <mat-icon class="header-icon">filter_alt</mat-icon>
              </button>
              <button class="icon-button" (click)="sortData('planNumber')">
                <mat-icon class="header-icon">swap_vert</mat-icon>
              </button>
            </div>
          </th>
          <td mat-cell *matCellDef="let element; let i = index"
            [ngClass]="[getRowClass(element.applicationStatus,element.statusReason), 'all-rows']">
            {{ element.planNumber }}
          </td>
        </ng-container>

        <ng-container matColumnDef="productType">
          <th mat-header-cell *matHeaderCellDef>
            <div class="header-content">
              <span class="header-title">Product Type</span>
              <button class="icon-button" (click)="openFilterDialog('productType')">
                <mat-icon class="header-icon">filter_alt</mat-icon>
              </button>
              <button class="icon-button" (click)="sortData('productType')">
                <mat-icon class="header-icon">swap_vert</mat-icon>
              </button>
            </div>
          </th>
          <td mat-cell *matCellDef="let element; let i = index"
            [ngClass]="[getRowClass(element.applicationStatus,element.statusReason), 'all-rows']">
            {{ element.productType }}
          </td>
        </ng-container>
        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
      </table>
    </div>
    <div class="footer mt-2 mb-1">
      <div class="row">
        <div class="button col-3">
          <button type="button" class="back-button" [routerLink]="['']">
            Back
          </button>
        </div>
        <div class="paginator col-9">
          <button class="paginator-button" (click)="prevPage()">
            Previous
          </button>
          <span class="page">Page {{ currentPage }} of {{ totalPage }}</span>
          <button class="paginator-button" (click)="nextPage()">Next</button>
        </div>
      </div>

      <div class="note mt-1">
        <p>
          <b>NOTE:</b> You can check the status of your application(s) again
          after 24 hours
        </p>
      </div>
      

  <div class="legend-font-style">
     <ul class="legend-padding">
    <li><span class="legend-green"></span> Approved Applications</li>
    <li><span class="legend-red"></span> Denied Applications</li>
    <li><span class="legend-black"></span> In progress, No Action Needed</li>
  </ul>
  </div>

    </div>

  </div>

  <div>
    <mat-paginator class="hidden-paginator" [pageSizeOptions]="[10]" showFirstLastButtons></mat-paginator>
  </div>
</div>